var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 20,
    viewBox: "0 0 23 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.0602 15.0295L14.3527 1.67943C13.0938 -0.525955 9.91021 -0.525955 8.65581 1.67943L0.943761 15.0295C-0.315165 17.2349 1.2517 19.9746 3.79219 19.9746H19.1846C21.7251 19.9746 23.3191 17.2077 22.0602 15.0295ZM11.4997 17.013C10.8295 17.013 10.2725 16.456 10.2725 15.7857C10.2725 15.1155 10.8295 14.5585 11.4997 14.5585C12.1699 14.5585 12.7269 15.1155 12.6998 15.8174C12.7315 16.456 12.1428 17.013 11.4997 17.013ZM12.6183 9.07901C12.5639 10.03 12.505 10.9765 12.4507 11.9274C12.4235 12.2354 12.4235 12.5162 12.4235 12.8196C12.3964 13.3222 12.0024 13.7117 11.4997 13.7117C10.9971 13.7117 10.6076 13.3494 10.5759 12.8467C10.4944 11.3659 10.4083 9.91226 10.3268 8.43144C10.2997 8.04199 10.2725 7.64801 10.2408 7.25855C10.2408 6.6155 10.6031 6.08567 11.1918 5.91811C11.7805 5.77773 12.3647 6.0585 12.6183 6.6155C12.7043 6.81023 12.7315 7.00496 12.7315 7.23138C12.7043 7.85179 12.6454 8.46767 12.6183 9.07901Z",
    fill: "#FF7575"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.dc511adbeeb8b7980fbe4bebede34e03.svg";
export { ForwardRef as ReactComponent };